import React from 'react'
import PropTypes from 'prop-types'
import { BREAKPOINT } from '../../constant'
import config from '../../config'
import { renderImageByBreakPoint } from '../../utils/common'

const ImageRender = props => {
  const { breakPoint, computer, mobile, tablet, width, height } = props

  return (
    <img
      width={width || 'auto'}
      height={height || 'auto'}
      src={renderImageByBreakPoint(breakPoint, { computer, mobile, tablet })}
      alt={'img'}
    />
  )
}

ImageRender.propTypes = {
  computer: PropTypes.string,
  tablet: PropTypes.string,
  mobile: PropTypes.string,
  breakPoint: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

export default ImageRender
